import { addDays, differenceInCalendarDays, endOfDay, startOfDay, subDays } from 'date-fns';
import type { DateRange } from '@/lib/api/activity-sync-schema';

export function buildDateChunks(range: DateRange, chunkCount: number): DateRange[] {
    if (chunkCount <= 0) {
        throw new Error('chunkCount must be greater than 0.');
    }

    const normalizedStart = startOfDay(range.start);
    const normalizedEnd = endOfDay(range.end);
    const totalDays = differenceInCalendarDays(normalizedEnd, normalizedStart) + 1;

    if (totalDays <= 0) {
        throw new Error('Date range must be at least one day.');
    }

    const baseChunkSize = Math.floor(totalDays / chunkCount);
    const remainder = totalDays % chunkCount;
    let cursor = normalizedStart;
    const chunks: DateRange[] = [];

    for (let index = 0; index < chunkCount; index += 1) {
        const daysInChunk = baseChunkSize + (index < remainder ? 1 : 0);
        const chunkStart = cursor;
        const rawChunkEnd = addDays(chunkStart, Math.max(0, daysInChunk - 1));
        const chunkEnd = index === chunkCount - 1 ? normalizedEnd : endOfDay(rawChunkEnd);

        chunks.push({ start: chunkStart, end: chunkEnd });
        cursor = startOfDay(addDays(chunkEnd, 1));
    }

    return chunks;
}

export function buildLast365DayChunks(referenceDate: Date = new Date()): DateRange[] {
    const rangeEnd = endOfDay(referenceDate);
    const rangeStart = startOfDay(subDays(rangeEnd, 364));
    return buildDateChunks({ start: rangeStart, end: rangeEnd }, 12);
}

